import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useCommissionsListFilterFields } from '../hooks/useCommissionsListFilterFields';

export type CommissionsListFilterFormValues = {
  name: string | null;
  status: string[];
  merchant: string | null;
  provider: string[];
  currency: string[];
  transactionTypes: string[];
  id: string | null;
  parent: string | null;
};

export const CommissionsListFilter: React.FC = () => {
  const fields = useCommissionsListFilterFields();

  return <FilterFields fields={fields} />;
};
